export const ConnectionStatus = Object.freeze({
  ClientDisconnected: 'ClientDisconnected',
  ClientConnected: 'ClientConnected',
  ClientReconnection: 'ClientReconnection'
})

export const RunStates = Object.freeze({
  RunEdit: 'RunEdit',
  RunStarted: 'RunStarted',
  RunConference: 'RunConference',
  RunFinished: 'RunFinished',
  Unknown: 'Unknown'
})

const ExerciseEventType = Object.freeze({
  ExerciseAdded: 'ExerciseAdded',
  ExerciseRemoved: 'ExerciseRemoved'
})

/**
 * @typedef DocumentEventType
 */
/**
 * @enum {DocumentEventType}
 */
const DocumentEventType = Object.freeze({
  DocumentRemoved: 'DocumentsRemoved',
  DocumentAdded: 'DocumentsAdded',
  DocumentsCleared: 'DocumentsCleared'
})

/**
 * @property {ConnectionStatus} connectionStatus
 * @property {RunStates} runState
 */
const state = {
  connectionStatus: ConnectionStatus.ClientDisconnected,
  runState: RunStates.Unknown,
  hubToken: ''
}

export default state;
